/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React, { useState, useMemo } from 'react';

const JsonPreview = ({ data, collapsedLines = 6, className = '' }) => {
  const [expanded, setExpanded] = useState(false);
  const json = useMemo(() => {
    try {
      return JSON.stringify(data ?? {}, null, 2);
    } catch (e) {
      return String(data);
    }
  }, [data]);

  const lines = json.split('\n');
  const shouldCollapse = !expanded && lines.length > collapsedLines;
  const display = shouldCollapse ? lines.slice(0, collapsedLines).join('\n') + '\n…' : json;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(json);
    } catch (e) {
      console.warn('Copy failed');
    }
  };

  return (
    <div className={`rounded-md border border-borderDefault bg-backgroundSurface p-2 ${className}`}>
      <pre className="text-xs whitespace-pre-wrap break-words text-textPrimary">{display}</pre>
      <div className="mt-2 flex items-center gap-2 text-xs">
        {lines.length > collapsedLines && (
          <button className="text-primary hover:underline" onClick={() => setExpanded((v) => !v)}>
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        )}
        <button className="text-textSecondary hover:underline" onClick={handleCopy}>Copy</button>
      </div>
    </div>
  );
};

export default JsonPreview;
